var CreditScoreBenefits = [
    {
        id: 1,
        imageUrl: "person_check.png",
        imageTitle: "person check",
        transKey: "noCreditScorePage.bodySection.benefits.transUnion",
    },
    {
        id: 2,
        imageUrl: "person_exclamation.png",
        imageTitle: "person exclamation",
        transKey: "noCreditScorePage.bodySection.benefits.influences",
    },
    {
        id: 3,
        imageUrl: "hand_watch.png",
        imageTitle: "hand watch",
        transKey: "noCreditScorePage.bodySection.benefits.trackCreditScore",
    },
    {
        id: 4,
        imageUrl: "person_interrogation.png",
        imageTitle: "person interrogation",
        transKey: "noCreditScorePage.bodySection.benefits.improveCreditScore",
    },
];
export default CreditScoreBenefits;
